import moment from 'moment';
import { DillTransaction, formatMoney } from '@dill/dill-shared';
import { DillModal } from '../Dill';

// Details for a payment made outside of Dill (isExternalPayment) - e.g. a check recorded in the
// supplier's ERP. These have no Dill payment method, receipt or refund actions.
export const AppExternalPaymentDetailsModal = ({
  transaction,
  accountType,
  onClose,
}: {
  transaction: DillTransaction | null;
  accountType: 'buyer' | 'supplier';
  onClose: () => void;
}) => {
  return (
    <DillModal
      open={!!transaction}
      onClose={onClose}
      closeOnOverlayClick
      maxWidth="520px"
      title={
        accountType === 'buyer'
          ? `Payment to ${transaction?.recipient?.name ?? 'supplier'}`
          : `Payment from ${transaction?.buyer?.name ?? 'customer'}`
      }
      subtitle={
        accountType === 'buyer'
          ? 'Paid outside Dill and recorded by your supplier'
          : 'Paid outside Dill and recorded in your ERP'
      }>
      {transaction && (
        <>
          <div className="grid grid-cols-3 gap-2">
            <div>
              <div className="text-[11px] text-gray-400 mb-0.5">Amount</div>
              <div className="text-sm font-semibold text-gray-900">
                {formatMoney(transaction.totalAmountPaid ?? 0, 2)}
              </div>
            </div>
            <div>
              <div className="text-[11px] text-gray-400 mb-0.5">Date</div>
              <div className="text-sm text-gray-900">
                {transaction.createdAt ? moment(transaction.createdAt).format('MM/DD/YYYY') : '-'}
              </div>
            </div>
            <div>
              <div className="text-[11px] text-gray-400 mb-0.5">Reference #</div>
              <div className="text-sm text-gray-900">
                {transaction.externalReferenceNumber || '-'}
              </div>
            </div>
          </div>
          <div className="border border-gray-100 rounded-lg max-h-[50vh] overflow-y-auto overscroll-contain">
            <div className="sticky top-0 grid grid-cols-3 gap-2 px-3 py-2 bg-gray-50 text-[11px] font-semibold text-gray-500">
              <div>Invoice #</div>
              <div className="text-right">Invoice Amount</div>
              <div className="text-right">Amount Applied</div>
            </div>
            {transaction.invoicePayments.map((inv, index) => (
              <div
                key={`${inv.invoiceNumber}-${index}`}
                className="grid grid-cols-3 gap-2 px-3 py-2 border-t border-gray-100 text-xs text-gray-900">
                <div>{inv.invoiceNumber}</div>
                <div className="text-right">{formatMoney(inv.amount ?? 0, 2)}</div>
                <div className="text-right">{formatMoney(inv.amountPaid ?? 0, 2)}</div>
              </div>
            ))}
          </div>
        </>
      )}
    </DillModal>
  );
};
